export default __webpack_public_path__ + "static/media/underMaintenance_6318436_lrg.113fdca3.jpg";